import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
const volumes = [['VOLUMEN 1 — Principios de Cooperación en el Cuidado™', ['Reconocés cuándo y cómo aparece la resistencia', 'Identificás señales tempranas de tensión', 'Observás qué ocurre antes y durante el rechazo', 'Te preparás antes de ofrecer ayuda', 'Aprendés qué hacer cuando la situación empieza a escalar'], 'border-blue-400/30'], ['VOLUMEN 2 — Estrategias de Comunicación para el Cuidado™', ['Tenés frases listas para distintas situaciones de rechazo', 'Sabés cómo ofrecer sin presionar', 'Aprendés a validar sin confrontar', 'Contás con recursos para responder al rechazo con más calma', 'Favorecés conversaciones más claras y ordenadas'], 'border-green-400/30'], ['VOLUMEN 3 — Protocolos de Acompañamiento sin Conflictos™', ['Aplicás un proceso paso a paso', 'Sabés qué hacer antes, durante y después', 'Contás con un plan práctico de 14 días para aplicar el sistema', 'Reducís la necesidad de improvisar en situaciones difíciles', 'Aplicás el sistema paso a paso en situaciones reales'], 'border-amber-400/30']] as const;
const bonuses = [['01', 'Mapa Rápido de Resistencia sin Discusión™', 'Identificá en 10 minutos qué suele ocurrir antes del rechazo y preparate mejor.', '$12.000'], ['02', 'Tarjetas de Frases para Responder sin Chocar™', '50 frases listas para usar en situaciones difíciles. Elegí la que mejor se adapte al momento y comunicá con más calma.', '$10.000'], ['03', 'Semáforo de Tensión para Pausar a Tiempo™', 'Identificá cuándo avanzar, cuándo bajar el ritmo y cuándo hacer una pausa.', '$9.000'], ['04', 'Plantilla de Primer Acercamiento Tranquilo™', 'Prepará tu primer acercamiento en 3 minutos. Fórmula A.C.E.R.C.A. lista para usar.', '$11.000'], ['05', 'Registro de 14 Días de Cooperación Posible™', 'Registro diario para observar lo ocurrido, ajustar tus estrategias y acompañar con más claridad.', '$10.000']] as const;
export function ProductOffer() {
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-130" data-mp="hxlbk5z6037l">
        <div className="mx-auto max-w-5xl" data-id="element-131" data-mp="mx6cglxwalmy">
          <header className="text-center" data-id="element-132" data-mp="mvv7iispr7u9">
            <h2 className="font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-133" data-mp="ro65vh7t2lkp">
              🏆 SISTEMA COOPERACIÓN SIN CONFLICTOS™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium sm:text-xl" style={{
            fontSize: "17px"
          }} data-id="element-134" data-mp="wmpvpspishic">
              Una hoja de ruta en 3 volúmenes para saber qué observar, qué decir
              y cómo actuar antes, durante y después de una situación de
              rechazo.
            </p>
            <p className="mx-auto mt-4 max-w-3xl text-sm text-slate-400" data-id="element-135" data-mp="8wddnp0k94e1">
              Contenido educativo y comunicacional. Complementa el
              acompañamiento médico; no lo reemplaza.
            </p>
            <h3 className="mt-12 font-display text-2xl font-bold" data-id="element-136" data-mp="1key0495b905e">
              📚 3 VOLÚMENES
            </h3>
          </header>
          <div className="mt-7 space-y-5" data-id="element-137" data-mp="39tpfzkc2mcvs">
            {volumes.map(([title, items, border], index) => <motion.article key={title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className={`flex gap-5 rounded-2xl border ${border} bg-brand-ink p-5 sm:p-7`} data-id="element-138" data-mp="34uw0jmd84bsz" data-mpi={index}>
                <BookOpenIcon className="mt-1 h-7 w-7 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-139" data-mp="2q7azrz3tmoo8" />
                <div data-id="element-140" data-mp="2m33ao0tgb6ph">
                  <h4 className="font-display text-lg font-bold sm:text-xl" data-id="element-141" data-mp="2m6r12r3lnczz">
                    {title}
                  </h4>
                  <ul className="mt-4 space-y-2" data-id="element-142" data-mp="2c6qf0xeciis3">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-143" data-mp="2c8jmgews9715">
                        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-144" data-mp="af3mgret2fti" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-brand-green/30 bg-brand-green/10 p-6 sm:p-8" data-id="element-145" data-mp="387m494uj44dt">
            <h4 className="text-center font-display text-xl font-bold" data-id="element-146" data-mp="2uaqicbt6iigc">
              El Sistema incluye:
            </h4>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-147" data-mp="2kiul12yx2wd6">
              {['Plan práctico de 14 días paso a paso', 'Frases listas para cada situación de rechazo', 'Guía para observar y anticipar la tensión', 'Registro diario imprimible'].map(item => <p key={item} className="flex gap-2 text-slate-200" data-id="element-148" data-mp="2bj7ey3v8t2ds">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-149" data-mp="2ggzijv592cxt" />
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-150" data-mp="26jl1pufezm4z">
        <div className="mx-auto max-w-5xl" data-id="element-151" data-mp="26l5vhhtwn11s">
          <header className="text-center" data-id="element-152" data-mp="1mwhwwiay4d49">
            <GiftIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-153" data-mp="1mxjgxc9xw9y4" />
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-154" data-mp="1ix95vl7aitce">
              5 BONOS ESTRATÉGICOS
            </h2>
            <p className="mt-2 font-semibold tracking-[.18em]" data-id="element-155" data-mp="1rwmc8504b1sw">
              SIEMPRE INCLUIDOS
            </p>
          </header>
          <div className="mt-10 space-y-4" data-id="element-156" data-mp="25v2m24ta18f9">
            {bonuses.map(([number, title, detail, value]) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-brand-gold/20 bg-brand-dark p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-157" data-mp="21thbwr84n88r">
                <span className="w-fit rounded-lg bg-brand-gold/10 px-3 py-2 font-bold text-brand-gold" data-id="element-158" data-mp="2amub2awsb63a">
                  BONO {number}
                </span>
                <div className="flex-1" data-id="element-159" data-mp="2pkmomxirtkeu">
                  <h3 className="font-bold" data-id="element-160" data-mp="2kl0a8kr7hy4g">{title}</h3>
                  <p className="mt-2 flex gap-2 text-sm leading-relaxed text-slate-300" data-id="element-161" data-mp="2kmla8pwai99p">
                    <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-162" data-mp="2rpjb39gdsw0j" />
                    {detail}
                  </p>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-163" data-mp="31m4lybf311ca">
                  <span className="text-sm text-slate-500 line-through" data-id="element-164" data-mp="36d4ihfkahhe9">
                    {value}
                  </span>
                  <span className="rounded-full bg-brand-light px-3 py-1 text-sm font-bold text-brand-ink" data-id="element-165" data-mp="3bcz4b4p7jgsg">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-brand-gold/30 bg-brand-gold/10 p-6 text-center" data-id="element-166" data-mp="3ke727lntafm0">
            <p className="text-xs font-bold tracking-[.17em] text-brand-gold" data-id="element-167" data-mp="3pbgq2wvjyj7q">
              VALOR TOTAL BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-slate-400 line-through" data-id="element-168" data-mp="1q17hxf8hkx8e">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-brand-gold" data-id="element-169" data-mp="1ne6i8jverzj4">
              GRATIS con tu Sistema Cooperación Sin Conflictos™
            </p>
          </div>
        </div>
      </section>
    </>;
}